import { computed, defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
    name: 'DpPageTitleDropdown',
    props: {
        value: { type: Object, default: null },
        placeholder: { type: String, default: null },
    },
    setup() {
        const dropdownVisible = ref(false);
        const titleText = computed(() => 'test');
        return {
            dropdownVisible,
            titleText,
        };
    },
});
